import { useEffect, useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { isTab } from './tabs'
import { ServiceEditor } from './ServiceEditor'

export default function Admin() {
  const params = useParams<{ service?: string; tab?: string }>()
  const navigate = useNavigate()
  const services = useQuery({ queryKey: ['services'], queryFn: api.services })

  const activeService = useMemo(() => {
    if (params.service) return params.service
    return services.data?.find((s) => s.enabled)?.code
  }, [params.service, services.data])

  useEffect(() => {
    if (!params.service && activeService) {
      navigate(`/prebid/${activeService}`, { replace: true })
    }
  }, [params.service, activeService, navigate])

  return (
    <div className="flex flex-col gap-4">
      {services.data && activeService && (
        <Tabs value={activeService} onValueChange={(v) => navigate(`/prebid/${v}`)}>
          <TabsList>
            {services.data.map((s) => (
              <TabsTrigger key={s.code} value={s.code} disabled={!s.enabled}>
                {s.label}
              </TabsTrigger>
            ))}
          </TabsList>
        </Tabs>
      )}
      {activeService ? (
        <ServiceEditor
          service={activeService}
          tab={isTab(params.tab) ? params.tab : 'sloty'}
          onTabChange={(t) => navigate(`/prebid/${activeService}/${t}`)}
          key={activeService}
        />
      ) : (
        <p className="text-sm text-muted-foreground">Brak skonfigurowanych serwisów.</p>
      )}
    </div>
  )
}
